export default __webpack_public_path__ + "static/media/python.2aeaf9b4.png";